class ClearLocalStorageData {
    clearStorage() {
        const now = new Date().getTime();
        const storageExpirationTime = 12 * 60 * 60 * 1000;
        const setupTime = localStorage.getItem('setupTime');
        let redirectTologin = false;

        if (now - setupTime > storageExpirationTime) {
            let myItem = localStorage.getItem('selectedLang');
            let defaultLang = localStorage.getItem('defaultLang');
            localStorage.clear();
            localStorage.setItem('defaultLang', defaultLang);
            localStorage.setItem('selectedLang', myItem);
            redirectTologin = true;
        }

        return redirectTologin;
    }
}

const ClearLocalStorage = new ClearLocalStorageData();

export { ClearLocalStorage };
